




























import gql from 'graphql-tag'
import { Component, Vue } from 'vue-property-decorator'

import AppFormCard from '@/components/AppFormCard.vue'
import AppTextInput from '@/components/AppTextInput.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { hrefWithAppsflyerId } from '@/firebase'
import { idbKeyval } from '@/idb'

@Component({
  components: {
    AppFormCard,
    AppTextInput,
    AppTitleBar
  }
})
export default class extends Vue {
  name = ''
  phone = ''
  orderId = ''

  get submitEnabled () {
    return this.name && this.phone && this.orderId
  }

  async onClickSubmit () {
    const { data } = await this.$apollo.mutate({
      mutation: gql`mutation ($input: AuthGuestOrderInput!) {
        authenticateWithGuestOrder(input: $input) {
          success
          message
          token
          user {
            id
          }
        }
      }`,
      variables: { input: { name: this.name, phone: this.phone, orderId: this.orderId } }
    })

    await idbKeyval.delete('currentUser')
    localStorage.setItem('identityProvider', 'GUEST')
    localStorage.setItem('token', data.authenticateWithGuestOrder.token)
    localStorage.setItem('userId', data.authenticateWithGuestOrder.user.id)

    location.href = hrefWithAppsflyerId(`/orders/${this.orderId}`)
  }
}
